const raw = import.meta.env.VITE_API_BASE_URL ?? '';

export function getApiBaseUrl(): string {
  return raw.replace(/\/$/, '');
}

export function apiUrl(path: string): string {
  const base = getApiBaseUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalized}` : normalized;
}
